import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';
import { Close } from '@mui/icons-material';
import React from 'react';

interface InfoDialogProps extends Omit<DialogProps, 'title'> {
  title: string | React.ReactNode;
  subtitle?: string;
  children: React.ReactNode;
  onClose: () => void;
  open: boolean;
}

export const InfoDialog = ({
  title,
  subtitle,
  children,
  onClose,
  open,
  maxWidth = 'sm',
  fullWidth = true,
  ...rest
}: InfoDialogProps): React.JSX.Element => (
  <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth={fullWidth} {...rest}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box>
        {title}
        {subtitle && (
          <Typography variant="caption" color="text.secondary" display="block">
            {subtitle}
          </Typography>
        )}
      </Box>
      <IconButton size="small" onClick={onClose}>
        <Close />
      </IconButton>
    </DialogTitle>
    <DialogContent>{children}</DialogContent>
  </Dialog>
);
